var _style, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithubIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1A1A1A;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40,4v32c0,2.2-1.8,4-4,4H24.7c-0.1-0.2-0.1-0.3-0.1-0.5v-1.8c0-1.9,0-4.7,0-6.2s-0.6-2.7-1.2-3.3 c4.1-0.4,8.3-1.9,8.3-8.7c0-1.9-0.7-3.5-1.9-4.7c0.2-0.4,0.8-2.2-0.2-4.7c0,0-1.5-0.5-5,1.8c-1.5-0.4-3-0.6-4.6-0.6 s-3.1,0.2-4.6,0.6c-3.5-2.3-5-1.8-5-1.8c-1,2.4-0.4,4.2-0.2,4.7c-1.2,1.2-1.9,2.8-1.9,4.7c0,6.8,4.2,8.3,8.3,8.7 c-0.5,0.5-1,1.2-1.2,2.4c-1,0.5-3.7,1.2-5.3-1.5c0,0-1-1.7-2.8-1.8c0,0-1.8,0-0.1,1.1c0,0,1.2,0.5,2,2.6c0,0,1.1,3.4,6.1,2.4 c0,1.5,0,5.8,0,6.2c0,0.2-0.1,0.4-0.2,0.5H4c-2.2,0-4-1.8-4-4V4c0-2.2,1.8-4,4-4h32C38.2,0,40,1.8,40,4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubIcon);
export default __webpack_public_path__ + "static/media/github-icon.6a44e53cabfb75d4bbc52edfc7725877.svg";
export { ForwardRef as ReactComponent };